import { render, staticRenderFns } from "./NXP.vue?vue&type=template&id=5a3c0688"
import script from "./NXP.vue?vue&type=script&lang=js"
export * from "./NXP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports